import React, { ReactNode, useMemo } from 'react';
import { useLanguage } from '../../locale/useLanguage';
import { EmptyStateType, getEmptyStateDetails } from './emptyStateHelper';

import './EmptyState.css';

type EmptyStateProps = {
  cta: ReactNode;
  type: EmptyStateType;
};

export const EmptyState: React.FC<EmptyStateProps> = ({ cta, type }) => {
  const [t] = useLanguage();
  const details = useMemo(() => getEmptyStateDetails(type, t), [t, type]);

  return (
    <div className="empty-state--container">
      <div className="empty-state--body">
        {details?.image ? <img className="empty-state--image" src={details?.image} /> : null}
        <h2 className="empty-state--title">{details?.title}</h2>
        <p className="paragraph">{details?.description}</p>
      </div>
      {cta}
    </div>
  );
};
